<!--suppress XmlUnusedNamespaceDeclaration -->
<template>
  <svg
    class="crypto-utils-logo"
    viewBox="0 0 489.86 489.86"
    id="svg828"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs832" />
    <g id="g826" />
    <g id="box" style="display: inline">
      <path
        d="m 487.658,129.18 -49,-66.7 c -2,-2 -4.8,-3.5 -7.6,-3.9 l -184,-57.6 c -2.1,-1 -4.2,-1 -6.3,0 l -183.3,57.8 c -1,0.2 -5.7,3.6 -9,7.5 l -46.2,62.9 c -2.1,3.1 -5.3,10.9 4.2,16.7 l 41.6,17.1 v 240.2 c 0,4.2 2.1,7.3 6.3,9.4 l 185.4,76 c 3.8,1.4 5.8,1.4 9.4,0 l 185.4,-76 c 4.2,-1 6.3,-5.2 6.3,-9.4 v -239.8 l 42.7,-17.5 c 9.1,-4.7 6.3,-13.6 4.1,-16.7 z m -460.4,2.1 35.2,-48.7 166.3,68.2 -35.9,49.3 z m 206.3,332.4 -164.6,-67.8 v -224.4 l 122.9,50.5 c 6.1,1.9 9.8,0.2 12.5,-3.1 l 29.2,-39.7 z m 11.5,-330 -154.7,-63.3 153.6,-48.5 155.2,48.6 z m 174.9,262.2 -164.6,67.7 v -285.9 l 30.2,41.1 c 2.1,3.1 6.5,5.1 12.5,3.1 l 121.9,-50 z m -121.9,-195.8 -36.5,-50 165.6,-67.7 36.5,50 z"
        id="path824"
      />
    </g>
    <g id="btc" style="display: inline">
      <path
        d="m 406.77342,310.826 c -8.94976,54.328 -45.3322,100.207 -81.22422,102.574 -35.90084,2.459 -57.76965,-39.762 -48.80227,-93.967 8.9292,-54.308 45.33219,-100.26 81.20366,-102.619 35.92237,-2.343 57.7902,39.724 48.82283,94.047 z m -35.46426,-21.491 c 1.32832,-13.057 -5.46011,-16.981 -14.75345,-17.655 l 3.01686,-18.19 -7.35812,0.453 -2.91996,17.808 c -1.92347,0.094 -3.92622,0.315 -5.93779,0.511 l 2.92876,-17.965 -7.37868,0.498 -3.01294,18.271 c -1.59164,0.139 -3.13824,0.264 -4.69268,0.393 l -10.12341,0.651 -1.96459,11.913 c 0,0 5.45913,-0.53 5.32503,-0.38 2.9963,-0.169 3.53663,2.33 3.45245,4.583 l -8.24987,50.002 c -0.41504,1.47 -1.35377,3.766 -3.42309,3.886 0.0666,0.12 -5.36809,0.367 -5.36809,0.367 l -3.68738,13.386 9.55763,-0.633 5.1919,-0.259 -3.0335,18.504 7.37868,-0.528 3.0335,-18.315 c 2.00667,-0.034 3.92622,-0.132 5.8448,-0.283 l -2.83186,18.101 7.37477,-0.46 3.0335,-18.492 c 12.52359,-1.876 21.95593,-7.128 25.92816,-24.755 3.18425,-14.202 -0.18011,-20.196 -6.78842,-22.296 4.7563,-3.521 8.38104,-9.485 9.38241,-19.085 z m -16.82766,40.218 c -2.2465,13.834 -17.63229,13.246 -22.62646,13.576 l 4.03488,-24.471 c 4.99906,-0.273 20.9712,-3.462 18.59158,10.895 z m 2.29641,-34.315 c -2.07911,12.597 -14.86699,11.999 -19.03598,12.256 l 3.67075,-22.29 c 4.14353,-0.318 17.51873,-3.191 15.36523,9.998 z"
        id="path1107"
        style="display: inline; stroke-width: 4.45219"
      />
    </g>
    <g id="eth" style="display: inline">
      <path
        id="path1097"
        style="display: inline; stroke-width: 5.97632"
        d="m 148.71373,359.73475 -63.16625,-62.26559 63.27465,112.43384 65.93486,-58.33967 -66.08354,8.15384 z m 0.5161,-146.21891 -62.704546,73.15703 63.116086,61.96877 66.0164,-8.4186 z"
      />
      <path
        style="
          fill: none;
          stroke: none;
          stroke-width: 1px;
          stroke-linecap: butt;
          stroke-linejoin: miter;
          stroke-opacity: 1;
        "
        d="m 83.119499,196.89783 c 134.898861,47.01021 134.217551,47.01021 134.217551,47.01021 l 2.04392,195.53521 v 0 L 82.438192,382.21344 v 0 z"
        id="path1240"
      />
      <path
        style="
          fill: none;
          stroke: #000000;
          stroke-width: 1px;
          stroke-linecap: butt;
          stroke-linejoin: miter;
          stroke-opacity: 1;
        "
        d="M 83.119499,196.89783 Z"
        id="path1476"
      />
    </g>
    <g id="tools" style="display: inline">
      <path
        d="m 219.56603,46.766447 c 11.47201,0.329483 12.95184,3.195731 11.03278,8.363278 -0.22385,0.590117 2.0086,0.557084 3.18351,0.570273 1.17612,0.0085 19.51972,0.09378 20.38971,0.108537 0.88451,0.0051 2.23729,-0.0824 2.41274,-0.617826 0.54087,-1.324224 1.14345,-2.638647 1.80895,-3.942664 4.61857,-9.407508 62.33557,1.469182 55.15543,-0.877008 -3.6179,-1.188099 -18.15242,-5.819253 -20.56758,-6.415299 -9.66427,-2.411288 -28.80889,-3.088162 -38.12226,-3.529207 -12.12783,-0.588181 -17.75554,-0.458227 -18.60133,-0.461615 -3.83328,-0.03836 -6.54368,1.862795 -13.54353,1.797455 -7.39189,-0.07187 -6.92846,-1.692306 -11.19855,-1.732357 -2.12597,-0.01682 -7.61816,-0.205821 -9.30611,-0.223487 -1.70852,-0.01513 -3.31419,0.379335 -3.60822,1.021361 0,0 -2.30626,5.916779 -2.55431,6.437079 -0.24079,0.514613 0.81191,1.388596 3.13874,1.403479 2.32562,0.01936 8.27277,0.07865 9.29401,0.07986 1.0043,0.015 6.07904,-2.128269 11.08602,-1.981859 z m 34.72216,14.008291 c 0.19481,-0.622666 -0.80949,-0.975139 -2.53737,-0.986029 l -19.19181,-0.184525 c -1.57058,-0.0051 -2.98265,0.406681 -3.19803,0.933394 l -16.32169,47.419902 c -0.44407,1.24267 1.8876,2.27238 5.20058,2.30021 l 14.24412,0.22869 c 3.34202,0.023 6.34766,-0.96679 6.73849,-2.21067 z m 109.97932,15.988093 c 2.8435,-1.499311 0.15609,-1.852026 -2.31473,-1.622368 -2.48897,0.235224 -13.23256,1.166924 -17.93462,1.65165 -4.6706,0.480249 -14.83339,1.142119 -17.5571,-3.645246 -2.7951,-4.873517 4.1503,-5.382564 8.30302,-5.88665 4.16361,-0.505538 16.1777,-1.7908 17.75433,-1.919786 1.58873,-0.133947 3.47754,-1.368268 -0.29645,-1.783782 -3.77641,-0.417087 -25.62901,-3.266274 -36.42705,-0.876282 -11.13079,2.456058 -15.09717,6.675207 -31.28092,6.918538 l -20.04486,0.419265 -2.12234,7.446461 23.95074,-0.127413 c 5.85882,-0.08954 14.9677,0.962555 19.39267,3.34081 9.66548,5.168999 21.0419,5.744233 32.59498,4.29066 10.26685,-1.284052 23.12673,-6.693599 25.98233,-8.205857 z M 137.20617,71.0503 c -3.11454,0.04683 -5.95562,0.940049 -6.36218,2.005212 l -1.64076,4.85452 c -0.4114,1.091299 2.5289,1.681295 5.69668,1.633016 l 73.43369,-0.841313 3.14237,-8.265026 z"
        id="path2755"
        style="stroke-width: 5.9895"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "CryptoUtilsLogo"
}
</script>

<style scoped>
.crypto-utils-logo {
  fill: var(--wren);
  width: 300px;
  margin-top: 5%;
  transition: transform 0.2s; /* Animation */
}

.crypto-utils-logo.dark-mode {
  fill: var(--cactus-wren) !important;
}

.crypto-utils-logo:hover {
  fill: var(--red-hawk) !important;
  transform: scale(1.1);
}

.crypto-utils-logo.dark-mode:hover {
  fill: var(--toucan) !important;
  transform: scale(1.1);
}

@media (prefers-color-scheme: dark) {
  .crypto-utils-logo {
    fill: var(--cactus-wren);
  }

  .crypto-utils-logo.light-mode {
    fill: var(--wren) !important;
  }

  .crypto-utils-logo:hover {
    fill: var(--toucan) !important;
  }

  .crypto-utils-logo.light-mode:hover {
    fill: var(--red-hawk) !important;
  }
}
</style>
